module.exports = __webpack_public_path__ + "media/images/pepsi_home/top_arrow-c74795adf1eff68f61bd2278f25c8cdc.png";